import { Controller } from 'stimulus';
import toArray from '../helpers/toArray';

class OldAndNewController extends Controller {
  connect() {
    this.checkHeights();
  }

  checkHeights() {
    const contentOne = this.contentTargets[0] || null;
    const contentTwo = this.contentTargets[1] || null;

    if (!contentOne || !contentTwo) {
      return;
    }

    const listOne = contentOne.querySelector('ul');
    const listTwo = contentTwo.querySelector('ul');

    // Loop over every item in list one
    toArray(listOne.querySelectorAll('li')).forEach((listItem, index) => {
      const listItemInListTwo = listTwo.querySelector(`li:nth-child(${index + 1})`);

      if (!listItemInListTwo) {
        return;
      }

      listItem.style.minHeight = '0px';
      listItemInListTwo.style.minHeight = '0px';

      if (window.innerWidth < 768) {
        return;
      }

      const heightOne = listItem.offsetHeight;
      const heightTwo = listItemInListTwo.offsetHeight;

      const maxHeight = heightTwo > heightOne ? heightTwo : heightOne;

      listItem.style.minHeight = `${maxHeight}px`;
      listItemInListTwo.style.minHeight = `${maxHeight}px`;
    });
  }
}

OldAndNewController.targets = [
  'content',
];

export default OldAndNewController;
